import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';

import { Subject } from 'rxjs'
import { ApiService } from 'src/app/_services/api.service';
import { AuthService } from 'src/app/_services/auth.service';

import { NotificationActionEnum } from 'src/app/chat/enums/notification-action.enum';
import { ChatService } from 'src/app/chat/services/chat/chat-service';
import { MessageModel } from 'src/app/chat/models/message.model';
import { Operations } from "../../_models/Reservation/ReservationStatus";
import { EventService } from "../../_services/event.service";
import { ReservationService } from "../../_services/reservation.service";

@Injectable({
  providedIn: 'root'
})
export class FiremessagingService {

  currentMessage = new Subject();
  message = new MessageModel();
  userId: string;

  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private apiService: ApiService,
    private eventService: EventService,
    private reservationService: ReservationService,
    private authService: AuthService,
  ) { }

  requestPermission() {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        if (token) {
          //deviceID = userID, because there is no device ID on browser
          this.authService.user.subscribe((userData) => {
            if (userData?.user?.id) {
              this.userId = userData?.user?.id;
            }
          });
          if (this.userId) {
            this.apiService.registerfcmtoken(this.userId as string, token).subscribe();
          }
        }
      },
      (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    );
  }
  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (payload) => {
        //@ts-ignore
        const obj = JSON.parse(payload.data.appData);
        //@ts-ignore
        if (payload.data.action == NotificationActionEnum.Chat) {
          //@ts-ignore
          this.message.createDate = payload.data.timestamp;
          this.message.fromSubscriber = true;
          //@ts-ignore
          this.message.id = payload.messageId;
          this.message.isSeen = true;
          this.message.subscriberChatId = obj.SubscriberChatId;
          this.message.messageText = obj.MessageText;
          this.currentMessage.next(this.message);
        } else {
          this.apiService.getEventDetails(obj.eventId).subscribe(eventDetails => {
            this.eventService.updateEventReservationsInfo(eventDetails);
          });
          let currentReservationsEventId = this.reservationService.getCurrentEventId();
          let currentStatus = this.reservationService.getCurrentStatus();
          if (currentReservationsEventId === obj.eventId) {
            this.reloadReservations(obj.eventId, currentStatus);
          }
        }
      });
  }

  reloadReservations(eventId: string, status: Operations): void {
    if (status === Operations.WaitingApproval) {
      this.apiService.getReservations(eventId, Operations.WaitingApproval).subscribe(_ =>
        this.apiService.getReservations(eventId, Operations.WaitingApprovalChanged, true).subscribe()
      );
    } else {
      this.apiService.getReservations(eventId, status, false).subscribe()
    }
  }
}
